import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
const STEPS = [{
  step: '01',
  title: 'Consultation',
  copy: 'We walk the space, listen to how you use it, and set a realistic scope, budget range, and timeline.'
}, {
  step: '02',
  title: 'Planning & Selections',
  copy: 'Materials, finishes, and sequencing are settled in writing before a single tool comes out.'
}, {
  step: '03',
  title: 'Construction',
  copy: 'One accountable crew, clean job sites, and weekly updates so you always know what happens next.'
}, {
  step: '04',
  title: 'Finish & Follow-Up',
  copy: 'A shared punch list, a final walkthrough, and a standing invitation to call us afterward.'
}];
export function ProcessSection() {
  return <section id="process" className="relative w-full bg-bone-100 py-24 sm:py-32" aria-labelledby="process-heading" data-id="element-141" data-mp="5b5evpyx0lqz">
      <div className="hairline-grid-dark absolute inset-0" aria-hidden="true" data-id="element-142" data-mp="9y73qwrvmkb" />
      <div className="relative mx-auto max-w-[1320px] px-6 lg:px-10" data-id="element-143" data-mp="vtjjrhwfpv13">
        <div className="max-w-2xl" data-id="element-144" data-mp="10ruuduuk09kd">
          <SectionLabel data-id="element-145" data-mp="10qt5amgpdmjn">How We Work</SectionLabel>
          <h2 id="process-heading" className="mt-7 font-display text-4xl font-light leading-[1.05] text-pine-950 sm:text-5xl" data-id="element-146" data-mp="mrtsqd6gsy3u">
            A calm, predictable build — start to finish.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-pine-950/60" data-id="element-147" data-mp="d0pc7915556w">
            By managing every phase of the process, we provide a seamless
            experience and results built to last.
          </p>
        </div>

        <ol className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-pine-900/10 bg-pine-900/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-148" data-mp="42wyg9b2i5lm">
          {STEPS.map((item, i) => <motion.li key={item.step} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: i * 0.08
        }} className="bg-bone-50 p-8" data-id="element-149" data-mp="3q9ldb6i9ufs0" data-mpi={i}>
              <span className="font-mono text-[11px] tracking-widest text-pine-600" data-id="element-150" data-mp="1vz52y6ecmcc6">
                {item.step}
              </span>
              <h3 className="mt-6 font-display text-2xl text-pine-950" data-id="element-151" data-mp="1n00a9gpgxd7x">
                {item.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-pine-950/60" data-id="element-152" data-mp="2jqangyv8hsst">
                {item.copy}
              </p>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}